import React from "react";
import FormFooterPartner from "../FormFooterPartner";
import CreateNewPassPartner from "./CreateNewPassPartner";
import { Constants } from "../../CommonMethods/Constants";

function CreatePasswordPartner() {
  return (
    <>
      <title>{Constants.Forget_Password}</title>
      {/* <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="row h-100">
              <div className="ipad-bottom m-auto"> */}
                <CreateNewPassPartner />
                {/* <FormFooterPartner /> */}
              {/* </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default CreatePasswordPartner;
